// extracted by mini-css-extract-plugin
module.exports = {"wrap":"wrap--25MfR","title":"title--fQmXD","list":"list--1nV5M","item":"item--3SbqP","data-title":"data-title--JLEhE","data-time":"data-time--27ifC"};